module.exports = __webpack_public_path__ + "static/media/alfa.f2c8b99a.png";